/**
 * Bundlerアプリのカートページでの挙動を調整するスクリプト
 *
 * formのsubmitボタンを押した際、本来は
 * 「/cartエンドポイントに向けてformをPOSTする」形でcheckoutに遷移するが
 * bundlerアプリはその元々の挙動を置き換えて
 * 「アプリで発行したcheckoutURLに遷移する」ように動作する
 * (`/checkout?discount={{discount-code}}`へのGETリクエストが実行される)
 * これによって、本来カートに付与されている他のdiscount情報は無視されて
 * bundlerアプリのdiscount情報だけが残ってしまう形になっている
 *
 * このbundlerアプリの挙動は要件に適さないため、以下2つの処理を実行し
 * どのアプリからのdiscountコードもcheckoutで適応されるようにする
 *
 * ・アプリから提供されている`preventBundlerCheckout`メソッドを適応し
 * 　submitボタンを押した際の挙動を本来の形に戻す
 *
 * ・bundlerアプリが発行したdiscountCodeをformに要素として追加する
 */
document.addEventListener('bundler:loaded', event => {
  window.bndlr.preventBundlerCheckout();

  const form = document.querySelector('form[action="/cart"][method="post"]');
  if (!form) return;

  window.bndlr.getCheckoutInfo(function(info) {
    if (!info.code) return;

    form.insertAdjacentHTML('afterbegin', `
      <input name="discount" type="hidden" value="${info.code}" />
    `);
  });
});
